// Structural navigation config for the four Atomika tools. Routes, names, brand
// glyphs/colors and static descriptions live here because the router and nav need
// them at build time. All *dynamic* values (status, KPIs, last-used) come from the
// backend overview endpoint — nothing dynamic is hardcoded.

export interface ToolConfig {
  id: string;
  route: string;
  name: string;
  tag: string;
  glyph: string;
  color: string;
  bg: string;
  dot: string;
  desc: string;
}

export const TOOLS: ToolConfig[] = [
  {
    id: "atomika-reiknivel",
    route: "/verkfaeri/atomika-reiknivel",
    name: "Atomika reiknivél",
    tag: "Sala & ávinningur",
    glyph: "kr",
    color: "#1E7BFF",
    bg: "#EAF2FF",
    dot: "#1E7BFF",
    desc: "Sölu- og ávinningsreiknivél: kostnaður, sparnaður, fjármögnun og samningstími.",
  },
  {
    id: "atomika-maelabord",
    route: "/verkfaeri/atomika-maelabord",
    name: "Atomika mælaborð",
    tag: "Rauntímarekstur",
    glyph: "◉",
    color: "#16A75C",
    bg: "#E7F7EF",
    dot: "#16A75C",
    desc: "Rauntímavöktun hitakerfa, viðskiptavina, frammistöðu og frávika.",
  },
  {
    id: "spalikan-orkunotkun",
    route: "/verkfaeri/spalikan-orkunotkun",
    name: "Spálíkan orkunotkunar",
    tag: "Greining & spár",
    glyph: "∿",
    color: "#7A5AF0",
    bg: "#EFEBFE",
    dot: "#7A5AF0",
    desc: "Greining og spá fyrir heitt vatn og orkunotkun bygginga.",
  },
  {
    id: "atomika-heimasida",
    route: "/verkfaeri/atomika-heimasida",
    name: "Atomika heimasíða",
    tag: "Markaðssamskipti",
    glyph: "⬡",
    color: "#0EA5B7",
    bg: "#E4F6F8",
    dot: "#0EA5B7",
    desc: "Opinber markaðs- og upplýsingavefur með reiknivél og dæmisögum.",
  },
  {
    id: "markadurinn",
    route: "/verkfaeri/markadurinn",
    name: "Atomika CRM",
    tag: "Sölupípa & samningar",
    glyph: "⇄",
    color: "#F0871E",
    bg: "#FEF1E3",
    dot: "#F0871E",
    desc: "Fyrirtæki, sölutækifæri, tilboð og samningar — sölupípa Laufið og Atomika. Tilboð berast beint úr reiknivél.",
  },
];

export function getTool(id: string): ToolConfig | undefined {
  return TOOLS.find((t) => t.id === id);
}
